// Return a random integer between `min` and `max` (inclusive).
export default function random(min, max) {
  if (max == null) {
    max = min;
    min = 0;
  }
  return min + Math.floor(Math.random() * (max - min + 1));
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/random.js
// module id = 498
// module chunks = 0